export default {
  'en': {
    'menu.by': 'By',
    'menu.followUs': 'Follow us',
    'menu.madeWith': 'Made with',
    'menu.musicalNotationWith': 'Musical notation with',
    'form.back': 'BACK',
    'form.info': 'INFO',
    'form.options': 'OPTIONS',
    'form.play': 'PLAY',
    'form.stop': 'STOP',
    'form.metronome': 'METRONOME',
    'form.sound': 'SOUND',
    'form.newSequence': 'NEW SEQUENCE',
    'form.realtime': 'REALTIME',
    'form.bars': 'Bars',
    'form.barReps': 'Bar Reps.',
    'form.bpm': 'BPM',
    'game.info.h1.gameDescription': 'GAME DESCRIPTION',
    'game.info.h2.name': 'Name',
    'game.info.h2.elementDescription': 'Element Description',
    'game.info.h2.goal': 'Goal',
    'game.info.h2.description': 'Description',
    'game.info.h2.workareas': 'Work Areas'
  },
  'es': {
    'menu.by': 'Por',
    'menu.followUs': 'Síguenos',
    'menu.madeWith': 'Desarrollado con',
    'menu.musicalNotationWith': 'Notación musical con',
    'form.back': 'VOLVER',
    'form.info': 'INFO',
    'form.options': 'OPCIONES',
    'form.play': 'PLAY',
    'form.stop': 'STOP',
    'form.metronome': 'METRÓNOMO',
    'form.sound': 'SONIDO',
    'form.newSequence': 'NUEVA SECUENCIA',
    'form.realtime': 'REALTIME',
    'form.bars': 'Compases',
    'form.barReps': 'Comp. Rep.',
    'form.bpm': 'BPM',
    'game.info.h1.gameDescription': 'DESCRIPCIÓN DEL JUEGO',
    'game.info.h2.name': 'Nombre',
    'game.info.h2.elementDescription': 'Descripción del Elemento',
    'game.info.h2.goal': 'Objetivo',
    'game.info.h2.description': 'Descripción',
    'game.info.h2.workareas': 'Áreas de Trabajo'
  }
}


// WEBPACK FOOTER //
// ./src/messages.js